/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  OauthApplication,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Show OAuth Application
 */
export const showOauthApplication = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<OauthApplication>(
      {url: `/oauth_applications/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowOauthApplicationQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'oauth_applications',id
    ] as const;
    }


export const getShowOauthApplicationQueryOptions = <TData = Awaited<ReturnType<typeof showOauthApplication>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showOauthApplication>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowOauthApplicationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showOauthApplication>>> = ({ signal }) => showOauthApplication(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showOauthApplication>>, TError, TData>
}

export type ShowOauthApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof showOauthApplication>>>
export type ShowOauthApplicationQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show OAuth Application
 */

export function useShowOauthApplication<TData = Awaited<ReturnType<typeof showOauthApplication>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showOauthApplication>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowOauthApplicationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






